import Navbar from "./Navbar";
import Hero from "./Hero";
import Marquee from "./Marquee";
import Features from "./Features";
import Genres from "./Genres";
import Lore from "./Lore";
import Gallery from "./Gallery";
import ReleaseCountdown from "./ReleaseCountdown";
import Newsletter from "./Newsletter";
import Footer from "./Footer";

export default function Landing() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Features />
        <Genres />
        <Lore />
        <Gallery />
        <ReleaseCountdown />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}
